import * as React from "react";
import {Option} from "ts-option";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import PartnerBrandForm from "../../partnerBrand/PartnerBrandForm";
import PartnerBrandPoints from "../../../model/partnerBrand/PartnerBrandPoints";
import {DealerPriceMatrixState} from "../../brand/dto/DealerPriceMatrixState";
import PartnerBrandCompanySection from "./sections/PartnerBrandCompanySection";
import PartnerBrandPayoutsSection from "./sections/PartnerBrandPayoutsSection";
import PartnerBrandLegacySection from "./sections/PartnerBrandLegacySection";
import {PartnerBrandSectionTitle} from "./sections/PartnerBrandSectionTitle";

interface ComponentProps {
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
	/**
	 * On add points
	 * @param {PartnerBrandPoints} point
	 */
	onAddPoints: (point: PartnerBrandPoints) => void
	/**
	 * Newly added points
	 */
	points: PartnerBrandPoints[],
	/**
	 * Partner brand identifier.
	 */
	partnerBrandId: Option<string>;
	/**
	 * On dealer price matrix change
	 */
	onDealerPriceMatrixChange: (state: DealerPriceMatrixState) => void
}

type Props = ComponentProps & FormBodyProps<PartnerBrandForm>;

/**
 * All sections of the partner brand form, one under another.
 */
const PartnerBrandFormBody = (props: Props) =>
	<div className={"c-create-brand"}>
		<PartnerBrandSectionTitle title={"Company"}/>
		<PartnerBrandCompanySection {...props}/>
		<PartnerBrandSectionTitle title={"Payouts"}/>
		<PartnerBrandPayoutsSection {...props}/>
		<PartnerBrandSectionTitle title={"Legacy"}/>
		<PartnerBrandLegacySection {...props}/>
	</div>;

export default PartnerBrandFormBody;
